import moment from 'moment';
import { BasketProduct, Product } from '../store/products';
import { ProductFilter } from '../store/products/types';

export const createSubProductUrn = (producturn: string, timeslot): string => {
  return `${producturn}:subrow:timeslot:${timeslot}`;
};

export const parseProductUrnFromSubProductUrn = (urn: string): { producturn: string; timeslot: number } => {
  // Split the urn by ':subrow:timeslot:' and return the first part
  const urns = urn.split(':subrow:timeslot:');
  return { producturn: urns[0], timeslot: Number(urns[1]) };
};

export const getPriceForProduct = (product) => {
  return product?.pricefordates?.length > 0
    ? product?.pricefordates[0].price || product?.budget
    : product?.standardprice || product?.budget;
};

export const getProductPrice = (product: Product) => {
  return product?.pricefordates?.length > 0
    ? product?.pricefordates[0].price || product?.budget
    : product?.standardprice || product?.budget;
};

export const getProductFrequency = (product: Product) => {
  return product?.pricefordates?.length > 0
    ? product?.pricefordates[0].frequency || product?.frequency
    : product?.frequency;
};

export const getBasketEntryId = (
  productUrn: string,
  productData: Product,
  productFilters: ProductFilter,
  basketProducts: BasketProduct[],
  basketProductsByUrn: IDictionary<BasketProduct>,
  timeslot: number = undefined,
): BasketProduct | undefined => {
  if (basketProducts && basketProducts.length) {
    if (timeslot) {
      // const price = productFilters?.isBudgetChanged
      //     ? productData?.budget
      //     : getProductPrice(productData);
      // const frequency = productFilters?.isBudgetChanged
      //     ? productData?.frequency
      //     : getProductFrequency(productData);

      // compare price, frequency, spotlength in the future, If needed
      const product = basketProducts.find((basketProduct) => {
        let productStartDate = productData.startdate;
        let productEndDate = productData.enddate;
        if (productFilters && productFilters?.dateRanges && productFilters?.dateRanges.length > 0) {
          productStartDate = productFilters?.dateRanges?.[0]?.startDate;
          productEndDate = productFilters?.dateRanges?.[0]?.endDate;
        }

        productStartDate = moment(productStartDate).format('DD/MM/YYYY');
        productEndDate = moment(productEndDate).format('DD/MM/YYYY');
        const basketStartDate = moment(basketProduct.basketstartdate).format('DD/MM/YYYY');
        const basketEndDate = moment(basketProduct.basketenddate).format('DD/MM/YYYY');

        return (
          basketProduct.producturn === productUrn &&
          basketProduct.baskettimeslot === timeslot &&
          basketStartDate === productStartDate &&
          basketEndDate === productEndDate
        );
      });
      return product ? product : undefined;
    } else {
      return basketProductsByUrn[productUrn] ? basketProductsByUrn[productUrn] : undefined;
    }
  } else {
    return undefined;
  }
};
